// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bluetooth';

export const Component = () => (
  <path
    fill='currentColor'
    d='M14.742 12.069 9.776 8.655l4.966-3.414a.362.362 0 0 0 .172-.31c0-.104-.034-.172-.138-.276L9.121.07C9.017.035 8.949 0 8.914 0c-.241 0-.38.104-.38.345v7.448L3.432 4.31a.264.264 0 0 0-.172-.07c-.241 0-.379.104-.379.346 0 .137.07.24.172.275l5.483 3.793-5.483 3.759a.362.362 0 0 0-.172.31c0 .241.138.345.38.345.033 0 .103-.034.206-.07l5.07-3.517v7.828c0 .242.137.345.379.345.069 0 .137-.034.207-.103l5.655-4.931c.103-.104.138-.172.138-.276 0-.103-.07-.207-.172-.276zM9.259 8.138V1.103l4.69 3.828-4.69 3.207zm4.724 4.242L9.26 16.517v-7.38l4.724 3.242z'
  />
);

export const viewBox = '0 0 18 18';
